import { Button, Typography, Grid2 } from '@mui/material';
import MainCard from 'components/MainCard';
import { Link } from 'react-router-dom';

interface NotFoundProps {
  icon: React.ComponentType<any> | null;
  text: any;
  link: string | null;

}

function NotFound({ icon: IconComponent, text, link }: Readonly<NotFoundProps>) {
  return (
    <MainCard sx={{ width: '100%', textAlign: 'center' }}>
      <Grid2 container sx={{ py: '110px' }}>
        <Grid2 size = {12}>
          {IconComponent && <IconComponent size="200" color="#3a568f" variant="Bold" />}
        </Grid2>
        <Grid2 size = {12}>
          <Typography variant="h6" sx={{ mt: -1, mb: 1 }}>
            {text}
          </Typography>
          {link ? (
            <Link to={link}>
              <Button sx={{ my: 1, px: 3, backgroundColor: '#3a568f', pointerEvents: 'none' }} variant="contained">
                + Add
              </Button>
            </Link>
          ) : null}
        </Grid2>
      </Grid2>
    </MainCard>
  );
}

export default NotFound;
